import { render } from "./OnTheWayIcon.vue?vue&type=template&id=0c2fc8a3&ts=true"
import script from "./OnTheWayIcon.vue?vue&type=script&lang=ts"
export * from "./OnTheWayIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/container/application/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__